import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const toasts = ref([])

  /**
   * Show a toast. Auto-dismisses after duration (default 2s). Use duration 0 for persistent.
   * If id is provided, any existing toast with that id is removed first (replace behavior).
   * @param {{ message: string, type?: 'success'|'error'|'info', duration?: number, id?: string, action?: { label: string, href?: string } }} options
   */
  function show(options) {
    const opts = typeof options === 'string' ? { message: options } : options
    const { message, type = 'success', duration = 2000, id: providedId, action } = opts
    const id = providedId ?? `toast-${Date.now()}-${Math.random().toString(36).slice(2)}`
    if (providedId) toasts.value = toasts.value.filter((t) => t.id !== providedId)
    const toast = { id, message, type, action }
    toasts.value = [...toasts.value, toast]

    if (duration > 0) {
      setTimeout(() => {
        remove(id)
      }, duration)
    }

    return id
  }

  function success(message) {
    return show({ message, type: 'success' })
  }

  function error(message) {
    return show({ message, type: 'error' })
  }

  function info(message) {
    return show({ message, type: 'info' })
  }

  function remove(id) {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  return { toasts, show, success, error, info, remove }
})
